var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaunch2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 545.523,
    height: 632.16,
    viewBox: "0 0 545.523 632.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2469fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12357b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-2258.557 -1768.775) rotate(-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_406527232",
    transform: "translate(1655 2373.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M3387.453,2489c23.778-5.552,40.918,10.743,45.384,28.365,6.035,23.417-10.984,42.487-28.486,46.35C3354.622,2574.334,3337.24,2500.827,3387.453,2489ZM3179,2596.906c4.828,4.1,55.4,17.14,65.783,20.64.483,18.467,2.052,20.4,8.811,34.279-2.173,5.673-19.192,22.691-19.916,26.192-1.207,4.828,20.036,22.209,22.813,23.175,4.587-2.173,19.313-20.036,24.5-24.985,6.88.845,11.588,2.655,19.433,2.9,7.362.242,15.208-1.327,21.485-.966,5.794,11.346,19.312,59.385,25.468,63.851,3.5.966,13.4-10.38,19.312-15.812,6.277-5.673,11.95-11.829,18.226-17.381,3.621-3.259,15.449-13.518,17.381-17.5,1.811-3.741,8.932-50.574,10.863-59.386,1.569-7.241,10.139-12.552,17.019-18.95l25.951-27.158c29.934-37.418,40.918-47.315,65.179-95.234,13.76-27.52,33.314-89.319,22.692-115.874-37.659-7.846-91.371,13.4-118.167,27.52-46.108,24.261-89.32,60.351-121.788,98.976-2.9,3.5-5.19,6.4-8.087,10.26-11.346,14.243-1.931,7.483-37.659,17.622-9.656,2.776-19.071,4.949-28.848,7.966-7.363,2.173-12.312,11.346-18.468,18.226-3.138,3.621-5.432,6.4-8.328,10.139-2.776,3.38-5.552,6.156-8.449,9.9C3189.5,2581.456,3179.362,2591.353,3179,2596.906Z",
    transform: "translate(-2995.789 -2373.004)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M1720.421,5255c30.9-30.9,64.575-64.334,68.076-67.834l106.339-106.339c3.259-6.4-6.4-16.053-12.795-14.725-3.862.965-134.462,132.772-190.468,188.9Zm-52.505,0,58.9-59.024c33.918-33.675,66.99-66.747,100.666-100.544,4.587-4.586,9.9-7.846,3.018-15.208-11.587-12.311-13.519-2.414-41.039,24.142-32.952,31.624-67.11,67.955-100.182,100.061-8.57,8.328-16.778,16.536-24.985,25.106l-9.294,9.053V5255Z",
    transform: "translate(-1655 -4740.928)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M2410.331,5670.617l108.994-109.234c3.138-3.139,10.38-7.845,7.121-14.846-1.448-3.139-7.725-10.019-13.76-7.242L2381,5670.617Z",
    transform: "translate(-2293.53 -5156.548)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M4686.654,3325.952c-50.212,11.829-32.832,85.337,16.9,74.715,17.5-3.862,34.522-22.933,28.487-46.35C4727.572,3336.695,4710.432,3320.4,4686.654,3325.952Z",
    transform: "translate(-4294.814 -3209.958)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 44.418,
    cy: 45.143,
    rx: 44.418,
    ry: 45.143,
    transform: "translate(2008.334 2481.635)",
    fill: "#fefefe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch2X);
export default __webpack_public_path__ + "static/media/launch2x.5d13b9d2df80b90ac41fa1c6def9c2ce.svg";
export { ForwardRef as ReactComponent };